export default __webpack_public_path__ + "static/media/business-cult.0a99d54b.webp";